export const useRules = () => {
  const requireRule = (
    value: string,
    msg: string = "請輸入"
  ): string | boolean => !!value || msg;

  const maxRule = (value: string, max: number): string | boolean =>
    !!value == false || value.length <= max || `字串長度超過${max}個字數`;

  return { requireRule, maxRule };
};
